import { render, staticRenderFns } from "./redBook.vue?vue&type=template&id=7ad397ca&scoped=true"
import script from "./redBook.vue?vue&type=script&lang=js"
export * from "./redBook.vue?vue&type=script&lang=js"
import style0 from "./redBook.vue?vue&type=style&index=0&id=7ad397ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad397ca",
  null
  
)

export default component.exports